import { SchoolPlugin } from './school-plugin'

export interface EnabledPluginInterface {
  /**
   * 全部应用列表
   */
  plugins?: SchoolPlugin[]
  /**
   * 置顶应用列表
   */
  pinnedPluginIds?: number[]
}

export class EnabledPlugin implements EnabledPluginInterface {
  /**
   * 全部应用列表
   */
  plugins?: SchoolPlugin[]
  /**
   * 置顶应用列表
   */
  pinnedPluginIds?: number[]

  constructor(props: EnabledPluginInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      plugins: _plugins,
      pinnedPluginIds: _pinnedPluginIds,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.plugins = _plugins
      ? _plugins.map((i) => new SchoolPlugin(i))
      : _plugins
    this.pinnedPluginIds = _pinnedPluginIds
  }
}
